import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

const PageTitle = ({ title, actions }) => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 0,
          mt: -1.5,
          px: 0.5
        }}
      >
        <Typography
          variant="h5"
          component="h1"
          sx={{
            fontWeight: 500,
            color: 'text.primary',
            fontSize: '1.5rem',
            lineHeight: 1.3
          }}
        >
          {title}
        </Typography>
        {actions && (
          <Box sx={{ display: 'flex', gap: 2 }}>
            {actions}
          </Box>
        )}
      </Box>
      <Divider sx={{ mb: 3 }} />
    </>
  );
};

export default PageTitle; 